import React from 'react'
// components
import RiskTemplate from 'components/PageComponents/RiskTemplates/Edit'
// layers
import RiskTemplateAPI from './layers/API'
import LogicalConditions from 'containers/Risks/RiskTemplate/Edit/layers/LogicalConditions'

const RiskTemplateContainer = () => (
  <RiskTemplateAPI>
    <LogicalConditions>
      <RiskTemplate />
    </LogicalConditions>
  </RiskTemplateAPI>
)

export default RiskTemplateContainer
